import _ from "lodash";
import * as L from "leaflet";
import Maneuver from "@/models/Maneuver";

export default class Lane {
	connectTos = [];
	isEnabled = true;
	laneDirectionDesc = "";
	laneId = -1;
	laneNumber = -1;
	laneSharingIds = [];
	laneTypeAttributeIds = [];
	laneTypeId = -1;
	maneuvers = [];
	nodes = [];
	roadName = "";
	signalGroups = [];

	constructor(args) {
		if (typeof args["connectTos"] === "object") {
			this.connectTos = _.map(
				args["connectTos"],
				connectTo => new ConnectTo(connectTo)
			);
		}

		if (args["isEnabled"] && args["isEnabled"] === false) {
			this.isEnabled = false;
		}

		if (args["laneDirectionDesc"]) {
			this.laneDirectionDesc = args["laneDirectionDesc"].toString();
		}

		if (typeof args["laneId"] === "number") {
			this.laneId = args["laneId"];
		}

		if (typeof args["laneNumber"] === "number") {
			this.laneNumber = args["laneNumber"];
		}

		if (typeof args["laneSharingIds"] === "object") {
			this.laneSharingIds = args["laneSharingIds"];
		}

		if (typeof args["laneTypeAtrributeIds"] === "object") {
			this.laneTypeAttributeIds = args["laneTypeAttributeIds"];
		}

		if (typeof args["laneTypeId"] === "number") {
			this.laneTypeId = args["laneTypeId"];
		}

		if (typeof args["maneuverIds"] === "object") {
			this.maneuvers = _.map(args["maneuverIds"], id => new Maneuver(id));
			this.maneuvers = this.maneuvers.sort(this.sortManeuvers);
		}

		if (typeof args["nodes"] === "object") {
			let enabledNodes = _.filter(args["nodes"], node => node.isEnabled);
			this.nodes = _.map(enabledNodes, node => {
				return new L.LatLng(node["latitude"], node["longitude"]);
			});
		}

		if (args["roadName"]) {
			this.roadName = args["roadName"].toString();
		}

		// TODO: Check this is correct
		if (this.connectTos.length > 0) {
			_.each(this.connectTos, connectTo => {
				const signalGroupId = connectTo.signalGroupId;
				const maneuverId = connectTo.maneuverId;

				const indexInArray = _.map(
					this.signalGroups,
					group => group.signalGroupId
				).indexOf(signalGroupId);

				if (indexInArray === -1) {
					this.signalGroups.push(new SignalGroup(signalGroupId, [maneuverId]));
				} else {
					this.signalGroups[indexInArray].addManeuverId(maneuverId);
				}
			});
		}
	}

	sortManeuvers(a, b) {
		return a.placement - b.placement;
	}
}

class ConnectTo {
	geoJSON = "";
	laneId = -1;
	maneuverId = -1;
	signalGroupId = -1;

	constructor(args) {
		if (args["connectToGeoJSON"]) {
			this.geoJSON = args["connectToGeoJSON"];
		}

		if (typeof args["connectToLaneId"] === "number") {
			this.laneId = args["connectToLaneId"];
		}

		if (typeof args["connectToManeuverId"] === "number") {
			this.maneuverId = args["connectToManeuverId"];
		}

		if (typeof args["connectToSignalGroupId"] === "number") {
			this.signalGroupId = args["connectToSignalGroupId"];
		}
	}
}

class SignalGroup {
	signalGroupId = -1;
	maneuverIds = [];

	constructor(signalGroupId, maneuverIds) {
		this.signalGroupId = signalGroupId;
		this.maneuverIds = maneuverIds;
	}

	addManeuverId(id) {
		this.maneuverIds.push(id);
	}
}
